class IconSet {
    
    constructor() { 
        this.icons = {};
    }
    
    register(code, icon) {       
        this.icons[code] = icon;
    }
    
    getIcon(code) {
        const icon = this.icons[code];

        if( icon ) {
            return `<img src="${icon}">`; 
        }
    }
}


export {
    IconSet
}